export const NOT_FOUND_404_URL = "/404";
export const LOGIN_URL = "/login";
export const CLAIMS_URL = "/claims";
export const POLICIES_URL = "/policies";
export const ADVISORS_URL = "/advisors";
export const DASHBOARD = "/dashboard";
export const WIDGETS = "/widgets";
